import { Component, OnInit, ViewContainerRef , Renderer2} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-echexadmin',
  templateUrl: './echexadmin.component.html',
  styleUrls: ['./echexadmin.component.css'],
  providers: [Modal]
})
export class EchexadminComponent extends EchexbaseComponent implements OnInit {

	public token: string;
  public user_token: string;
	public id: string;
	show: boolean = true;
	busy: Subscription;

	public data;
	public filterQuery = "";
	public rowsOnPage = 10;
	public sortBy = "created_at";
	public sortOrder = "desc";

	public dataNotFound = false;
	
  constructor(protected router: Router, private renderer: Renderer2, protected  route: ActivatedRoute, vcRef: ViewContainerRef, public modal: Modal, protected toastr: ToastrService, protected userService :UserService, protected echexpaymentService :EchexpaymentService, protected localStorageService: LocalstorageService) { 
	super(route, router, toastr, userService, echexpaymentService, localStorageService);
	let userDetails = <any>{};
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	userDetails = this.localStorageService.getData("currentUser");
	this.id = userDetails._id
	//modal.defaultViewContainer = vcRef;
  }

  ngOnInit() {
	  this.getAdmin();
  }

  ngAfterViewInit() {
		this.renderer.selectRootElement('#initialSearch_check').focus();
	}
  // Get Admin
   getAdmin(){
     var data = {
      token:this.token,
      user_token:this.token,
      id:this.id,
    }
    
	let adminData = <any>{};
    this.busy = this.echexpaymentService.getAdminList(data).subscribe(
         response => {
           adminData = response;
           if(adminData.data.length == 0){
             this.dataNotFound =  adminData.message;
           }
           else{
              this.data =  JSON.parse(JSON.stringify(adminData.data));
           }
         },
          error => {
          adminData = error;
          this.toastr.error(adminData.error.message, 'Failed!');
	   }
    );  
  }

  //invoke access and resend invite
	actionAccessAdmin(event,m_id, status_id){
    event.stopPropagation();
     var action  = '';
     if(status_id == 0){
     action = 'resend'
     }
     if(status_id == 3){
     action = 'revoke'
     }
     if(status_id == 5){
      action = 'invoke'
      }
     
     var data = {
       token:this.token,
       user_token:this.token,
       _id:m_id,
       status:status_id,
       action:action,
     }
    let response_action = <any>{};
    this.busy  =   this.userService.actionAccessApi(data).subscribe(
     response => {
       response_action = response;
       this.toastr.success(response_action.message, 'Success!');
       this.getAdmin();
     },
     error => {
       response_action = error;
       this.toastr.error(response_action.error.message, 'Failed!');		}
     );
   }
  // Delete Admin
  deleteAdmin(event,m_id){
  event.stopPropagation();
    this.modal.confirm()
      .size('sm')
      .title('CasherPay')
      .body(`Are you sure to delete this Admin.`)
      .okBtn('Okay')
      .cancelBtn('Cancel')
      .okBtnClass('btn btn-success')
      .cancelBtnClass('btn btn-warning')
   .open()
    .then( (resultPromise) => {
        resultPromise.result.then( (result) => {
         var data = {
            token:this.token,
            id:m_id,
            status:'11'
          }
		let delete_response = <any>{};
        this.echexpaymentService.deleteMerchant(data).subscribe(
             response => {
				delete_response = response;
				       this.toastr.success(delete_response.message, 'Success!');
               this.getAdmin();
             },
              error => {
				delete_response = error;
				      this.toastr.error(delete_response.error.message, 'Failed!');
		   }
        );
      }, 
      () => {
       console.log('Cancel');
      } );
  });
  }
  // Admin Lock/Unlock
  adminLockUnlock(event,m_id, status_id, label:string){
  event.stopPropagation();
    this.modal.confirm()
      .size('sm')
      .title('Casherpay')
      .body(`Are you sure to ${label} this Admin.`)
      .okBtn('Okay')
      .cancelBtn('Cancel')
      .okBtnClass('btn btn-success')
      .cancelBtnClass('btn btn-warning')
   .open()
    .then( (resultPromise) => {
        resultPromise.result.then( (result) => {
          var data = {
            token:m_id,
            user_token:this.token,
            id:m_id,
            status:status_id
          }
	   let ul_response = <any>{};
       this.busy  =   this.echexpaymentService.merchantLockUnlock(data).subscribe(
             response => {
				ul_response = response;
                this.toastr.success(ul_response.message, 'Success!');
                this.getAdmin();
             },
             error => {
				ul_response = error;
				    this.toastr.error(ul_response.error.message, 'Failed!');
		    }
        );
      }, 
      () => {
       //console.log('Cancel');
      } );
  });
  }

  

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexadmin/echexadmin.component.ts